import { type Plugin, defineNuxtPlugin, useState } from '#app'

import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'
import { toBcp47Locale } from '@backmarket/utils/string/toBcp47Locale'

import useI18nLocaleFromCookies from './composables/useI18nLocaleFromCookies'
import useI18nLocaleFromHeaders from './composables/useI18nLocaleFromHeaders'
import { NUXT_STATE_KEY, PROCESS_KEY } from './constants'
import type { I18n, I18nState } from './types'

export type Injections = {
  i18n: I18n
}

const plugin: Plugin<Injections> = defineNuxtPlugin<Injections>((nuxtApp) => {
  if (nuxtApp.ssrContext) {
    const cookiesLocale = useI18nLocaleFromCookies()
    const headersLocale = useI18nLocaleFromHeaders()
    const { market } = useMarketplace()
    const locale = toBcp47Locale(
      cookiesLocale || headersLocale || market.defaultLocale,
    )

    if (!process[PROCESS_KEY]) {
      throw new Error(
        '[nuxt-module-i18n] Cannot retrieve translations from the main process',
      )
    }

    const translations = process[PROCESS_KEY].translationsByLocale[locale]

    if (translations === undefined) {
      throw new Error(
        '[nuxt-module-i18n] Cannot retrieve translations for current locale',
      )
    }

    useState<I18nState>(NUXT_STATE_KEY, () => ({
      locale,
      translations,
    }))
  }

  if (!useState<I18nState>(NUXT_STATE_KEY).value) {
    throw new Error(
      '[nuxt-module-i18n] Cannot retrieve translations in useState',
    )
  }
})

export default plugin
